export default function getDefaultDeliveryDate() {
  // Initially Set to Today ( First Day in the schedule list of days from API )
  const deliveryDate = 0;
  return deliveryDate;
}
